import { render, staticRenderFns } from "./TemporaryCountingAdd.vue?vue&type=template&id=68194ed7"
import script from "./TemporaryCountingAdd.vue?vue&type=script&lang=js"
export * from "./TemporaryCountingAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports